import React, { FC, useEffect } from 'react'

interface Props {
  visible: boolean
  className?: string
  onBackgroundClick?: () => void
}

const Drawer: FC<Props> = ({ visible, className = '', onBackgroundClick, children }) => {
  useEffect(() => {
    visible ? document.body.classList.add('drawer__opened') : document.body.classList.remove('drawer__opened')
  }, [visible])

  return (
    <div className={`drawer__wrapper ${visible ? 'drawer__wrapper--visible' : ''} ${className}`}>
      <div
        className={`drawer__background ${visible ? 'drawer__background--visible' : ''}`}
        onClick={() => onBackgroundClick?.()}
      />

      <div className="drawer__inner">{children}</div>
    </div>
  )
}

export default Drawer
